<!------------ START TEMPLATE ------------>
<template>
  <div class="vx-row img">
    <div class="vx-col containerimg w-full mb-2 text-center mt-4">
      <h4 class="mb-3">{{ this.label }}</h4>
      <center>
        <img :src="this.imageUrl" width="100%" style="max-width: 250px" />
      </center>
      <input :id="inputId" type="file" hidden v-on:change="upload" />
      <vs-button
        color="warning"
        type="border"
        class="mr-3 mt-2 text-center"
        @click="chooseFiles()"
      >
        Escolher uma Imagem
        <feather-icon icon="UploadIcon" class="ml-2" />
        <Br />
        <vs-chip v-if="imageName" class="mt-3">
          <vs-avatar icon-pack="feather" icon="icon-file" />
          <span>{{ imageName }}</span>
        </vs-chip>
      </vs-button>
    </div>
  </div>
</template>
<!------------ START TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import service from "../../../services";

export default {
  components: {},
  props: ["path", "label", "imageUrl"],
  watch: {},
  data() {
    return {
      inputId: `fileUpload-${new Date().getTime()}`,
      imageName: null,
    };
  },
  methods: {
    chooseFiles() {
      document.getElementById(this.inputId).click();
    },
    upload(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      const [file] = files;
      this.imageName = file.name;

      const form = new FormData();
      form.set("file", file, file.name);

      this.$vs.loading();
      service
        .upload("Upload", `${this.path}`, form)
        .then((response) => {
          this.$emit("uploaded", response);
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style >
#fileInput {
  display: none;
}
.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}
</style>
<!------------ END STYLE ------------>
